import { Navigate, useParams } from 'react-router-dom';

export function GameRedirect() {
  const { gamePk } = useParams<{ gamePk: string }>();
  return <Navigate to={`/baseball/mlb/game/${gamePk}`} replace />;
}
